import { render, staticRenderFns } from "./Organizado.vue?vue&type=template&id=70b63014&"
import script from "./Organizado.vue?vue&type=script&lang=ts&"
export * from "./Organizado.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports